var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"section-footer",on:{"scroll":_vm.onScroll}},[_c('FooterLeft',{attrs:{"sectionAttributes":_vm.sectionAttributes}}),(_vm.sectionAttributes.footer_details[0])?_c('FooterDetails',{attrs:{"footer_details":_vm.sectionAttributes.footer_details[0]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }